import { Box, Button, Divider, Flex, Text } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { FunctionComponent } from "react";
import { AddressValidationResult } from "src/components/Boundary/services";
import { FormAddress } from "src/schemas/Address";
import { FormattedAddress } from "./FormattedAddress";

type ResolveInvalidAddressProps = {
  setAddressValidationResult: (
    result: AddressValidationResult | undefined
  ) => void;
};

export const ResolveInvalidAddress: FunctionComponent<
  ResolveInvalidAddressProps
> = (props) => {
  const { setAddressValidationResult } = props;
  const { values, submitForm } = useFormikContext<FormAddress>();

  return (
    <Box width="100%">
      <Box padding={4}>
        <Text fontWeight={700}>The entered address cannot be found</Text>
        <Text color="blackAlpha.800" fontWeight={400}>
          <FormattedAddress address={values} />
        </Text>
      </Box>
      <Divider />
      <Flex padding={4} gap={2}>
        <Button
          variant="outline"
          colorScheme="gray"
          onClick={submitForm}
          width="50%"
        >
          Use entered
        </Button>
        <Button
          variant="outline"
          colorScheme="primary"
          onClick={() => {
            setAddressValidationResult(undefined);
          }}
          width="50%"
        >
          Edit address
        </Button>
      </Flex>
    </Box>
  );
};
